import styled from "@emotion/styled";

export const PaintChipInstructionsContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	display: "flex",
	flexDirection: "row",
	gap: "16px",
	padding: "16px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const PaintChipInstructionsTextContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "8px"
});

export const PaintChipInstructionsTitle = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.secondary
}));

export const PaintChipInstructionsSubtitle = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main
}));

export const PaintChipInstructionsList = styled.ol({
	margin: 0,
	paddingLeft: "16px"
});

export const PaintChipInstructionsListItem = styled.li(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));
